

export const taxCalculator = (total, tax) => {
  const res = parseFloat(total * tax) / 100;
  return res;
}

export const taxCalculatorNew = (amount, tax, unit = 1) => {
  let amt = parseFloat(amount);
  let IntTex = parseFloat(tax);
  let IntUnit = parseInt(unit);
  // if (typeof amt !== 'number' || typeof IntTex !== 'number' || typeof unit !== 'number') {
  //  return 'All parameters must be numbers.';
  // }

  const calculatedTax = (IntTex / 100) * amt;
  return calculatedTax * IntUnit;
};


export const finalAMT = (base, tax1, tax2) => {
  const tx = parseFloat(tax1) + parseFloat(tax2);
  const f = parseFloat(base) + parseFloat(tx);
  return f
}

export const capitalizeFirstLetter = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export const monthMap = () => {
  const data = {
    'January': 1,
    'February': 2,
    'March': 3,
    'April': 4,
    'May': 5,
    'June': 6,
    'July': 7,
    'August': 8,
    'September': 9,
    'October': 10,
    'November': 11,
    'December': 12
  };
  return data;
}

export const sortByKeyAndRemoveDuplicates = (array) => {
  array.sort((a, b) => {
    const nameA = a.name.toUpperCase();
    const nameB = b.name.toUpperCase();
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    return 0;
  });

  // Step 2: Remove duplicate entries based on 'id' field
  const uniqueArray = array.filter((obj, index, self) =>
    index === self.findIndex((t) => t.id === obj.id)
  );

  return uniqueArray;
}


export const adjAmountSubTotal = (amount, discount, tax, qty) => {
  const baseAmt = amount * qty;
  const amt = baseAmt - parseFloat(discount) + parseFloat(tax);
  return parseFloat(amt);
};

export const yesNoOption = [
  { label: 'Yes', value: "Yes" },
  { label: 'No', value: "No" },
]




export const validateFile = (file) => {
  // Check MIME type
  const allowedMimeTypes = ['image/jpeg', 'image/png'];
  if (!allowedMimeTypes.includes(file.type)) {
    return { valid: false, message: 'Only JPG, JPEG, and PNG files are allowed.' };
  }

  // Check file size (20MB = 200 * 1024 * 1024 bytes)
  const maxSizeInBytes = 20 * 1024 * 1024;
  if (file.size > maxSizeInBytes) {
    return { valid: false, message: 'File size must be less than 20MB.' };
  }
  // If both checks pass
  return { valid: true, message: 'File is valid.' };
};



  // Function to handle file selection and validation
  const handleFileChange = (e) => {
    const file = e.target.files[0]; // Get the selected file

  };

